import { ResponseError, ServerError } from '@/types/Error';
import { SerializedError } from '@reduxjs/toolkit';
import { FetchBaseQueryError } from '@reduxjs/toolkit/dist/query';

export const isExpectedError = (error: FetchBaseQueryError | SerializedError | undefined) => {
  const responseError = error as ResponseError;

  const status = Number(responseError?.status);
  return status >= 400 && status < 500;
};

export function getServerFormattedErrors(validationErrors?: string | unknown) {
  if (validationErrors) {
    const responseErrors = JSON.parse(validationErrors as string) as ServerError;
    const serverErrors = {} as Record<string, unknown>;

    for (let key in responseErrors) {
      serverErrors[key] = responseErrors[key]?.[0] ?? '';
    }

    return serverErrors;
  }
  return null;
}
